import { render, staticRenderFns } from "./PickingList.vue?vue&type=template&id=11d3487b"
import script from "./PickingList.vue?vue&type=script&lang=js"
export * from "./PickingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PickingList.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d3487b')) {
      api.createRecord('11d3487b', component.options)
    } else {
      api.reload('11d3487b', component.options)
    }
    module.hot.accept("./PickingList.vue?vue&type=template&id=11d3487b", function () {
      api.rerender('11d3487b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/PickingList.vue"
export default component.exports